import React from 'react'
import { l, Modal, StateScreen } from '@manychat/manyui'

const MODAL_WIDTH = 460

interface BusinessAgentPausedModalProps {
  isOpen: boolean
  onClose: () => void
}

export const BusinessAgentPausedModal = ({ isOpen, onClose }: BusinessAgentPausedModalProps) => {
  return (
    <Modal
      open={isOpen}
      width={MODAL_WIDTH}
      onRequestClose={onClose}
      data-test-id="cms-business-agent-paused-modal"
    >
      <div className="d-flex justify-center">
        <StateScreen
          type="icon"
          status="warning"
          header={l.translate(
            'WhatsApp automations are paused while Meta Business Agent is active',
          )}
          text={l.translate(
            'Meta Business Agent and WhatsApp automations can’t send messages at the same time. Your automations for other channels will continue to work.',
          )}
          action={{
            variant: 'primary',
            label: l.translate('Got it'),
            onClick: onClose,
          }}
        />
      </div>
    </Modal>
  )
}
